import React from "react";

import { SocialIconProps, SocialType } from "./models";

import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Box } from "@mui/material";

import "./style.scss";

export default class SocialIcon extends React.Component<SocialIconProps, {}> {

    private goToUrl = () => {
        window.open(this.props.url, '_blank');
    }

    render() {
        return (<Box className="si-main" onClick={this.goToUrl}>
            {this.props.social === SocialType.FACEBOOK &&
                <FacebookIcon />}
            {this.props.social === SocialType.TWITTER &&
                <TwitterIcon />}
            {this.props.social === SocialType.INSTAGRAM &&
                <InstagramIcon />}
            {this.props.social === SocialType.LINKEDIN &&
                <LinkedInIcon />}
        </Box>);
    }
}

